import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {OphButtonModule} from '../design/oph-button/oph-button.module';
import {OphColorPickerModule} from '../design/oph-color-picker/oph-color-picker.module';
import {OphIconModule} from '../design/oph-icon/oph-icon.module';
import {OphInputsModule} from '../design/oph-inputs/oph-inputs.module';
import {DialogLayoutModule} from '../dialog/layout/dialog-layout.module';
import {PipesModule} from '../pipes/pipes.module';
import {CreateProjectDialogComponent} from './create-project-dialog/create-project-dialog.component';
import {ProjectSelectorDialogComponent} from './project-selector-dialog/project-selector-dialog.component';
import {RenameSubtaskComponent} from './rename-task/rename-subtask.component';
import {UserHasRoleOptionDirective} from '../directives/user-has-role-option.directive';

@NgModule({
  declarations: [ProjectSelectorDialogComponent, CreateProjectDialogComponent, RenameSubtaskComponent],
  imports: [
    CommonModule,
    DialogLayoutModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    OphIconModule,
    OphColorPickerModule,
    MatInputModule,
    FormsModule,
    MatIconModule,
    OphInputsModule,
    OphButtonModule,
    MatMenuModule,
    PipesModule,
    MatProgressSpinnerModule,
    UserHasRoleOptionDirective,
  ],
  exports: [ProjectSelectorDialogComponent],
})
export class SharedProjectsModule {}
